@if (isspiner) {
  <div class="example-loading-shade">
    <mat-spinner [style.zoom]="1"></mat-spinner>
  </div>
}
<div class="p-20">
  <div class="cardblockwrap">
    <div class="grid w-[99%] grid-cols-1 items-start gap-5 xl:grid-cols-2">
      <div class="flex flex-col gap-6">
        <!--START Data -->
        <form class="w-full" [formGroup]="PreferenceForm">
          <mat-card appearance="outlined" class="p-3">
            <mat-card-header class="margin-x-header-0 mb-3 px-4 pb-1">
              <mat-card-title class="text-[20px]">Data</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div class="justify-content-between block-boxwrap flex">
                <div class="min-w-0 flex-1">
                  <h6 class="font-size-12 font-weight-800 mt-0 mb-1">Sort by Surname</h6>
                  <span class="block text-sm">
                    Contact names will be sorted by Surname, otherwise it will sort by their full
                    name
                  </span>
                </div>
                <mat-slide-toggle
                  class="shrink-0"
                  formControlName="SORTBYSURNAME"
                  (change)="checkboxClick('SORTBYSURNAME')"
                ></mat-slide-toggle>
              </div>

              <div class="justify-content-between block-boxwrap flex">
                <div class="min-w-0 flex-1">
                  <h6 class="font-size-12 font-weight-800 mt-0 mb-1">
                    Sort Matter Alpha Numerically
                  </h6>
                  <span class="block text-sm">
                    The Matter number will be sorted using alphabetic sorting not numeric sorting
                  </span>
                </div>
                <mat-slide-toggle
                  class="shrink-0"
                  formControlName="SORTMATTERALPHANUMERICALLY"
                  (change)="checkboxClick('SORTMATTERALPHANUMERICALLY')"
                ></mat-slide-toggle>
              </div>

              <div class="justify-content-between block-boxwrap flex">
                <div class="min-w-0 flex-1">
                  <h6 class="font-size-12 font-weight-800 mt-0 mb-1">
                    Sort Packets Alpha Numerically
                  </h6>
                  <span class="block text-sm">
                    The Packet Number will be sorted using alphabetic sorting not numeric sorting
                  </span>
                </div>
                <mat-slide-toggle
                  class="shrink-0"
                  formControlName="SORTPACKETSALPHANUMERICALLY"
                  (change)="checkboxClick('SORTPACKETSALPHANUMERICALLY')"
                ></mat-slide-toggle>
              </div>

              <div class="justify-content-between block-boxwrap flex">
                <div class="min-w-0 flex-1">
                  <h6 class="font-size-12 font-weight-800 mt-0 mb-1">Load All Users' Matters</h6>
                  <span class="block text-sm">
                    If off, you will only see matters where you are the Primary Fee Earner
                  </span>
                </div>
                <mat-slide-toggle
                  class="shrink-0"
                  formControlName="LOADALLUSERSMATTERS"
                  (change)="checkboxClick('LOADALLUSERSMATTERS')"
                ></mat-slide-toggle>
              </div>

              <div class="justify-content-between block-boxwrap flex">
                <div class="grow">
                  <h6 class="font-size-12 font-weight-800 mt-0 mb-4">
                    Always Popup Select Matter window first
                  </h6>
                  <span class="line-clamp3 d-block">
                    It will show the select matter window automatically, if it is off, you will need
                    to type in the matter number to search
                  </span>
                </div>
                <mat-slide-toggle
                  class="shrink-0"
                  formControlName="POPUPSELECTMATTERFIRST"
                  (change)="checkboxClick('POPUPSELECTMATTERFIRST')"
                ></mat-slide-toggle>
              </div>

              <div class="justify-content-between block-boxwrap flex">
                <div class="min-w-0 flex-1">
                  <h6 class="font-size-12 font-weight-800 mt-0 mb-1">Pre-fill time of the Day</h6>
                  <span class="block text-sm">
                    When entering time-entries, time of day will be automatically pre-filled
                  </span>
                </div>
                <mat-slide-toggle
                  class="shrink-0"
                  formControlName="PREFILLTIMEOFDAY"
                  (change)="checkboxClick('PREFILLTIMEOFDAY')"
                ></mat-slide-toggle>
              </div>

              <div class="justify-content-between block-boxwrap flex">
                <div class="min-w-0 flex-1">
                  <h6 class="font-size-12 font-weight-800 mt-0 mb-1">
                    Show Disbursements automatically
                  </h6>
                  <span class="block text-sm">
                    In the matter details window is opened, automatically display disbursements in
                    the Work In Progress tab
                  </span>
                </div>
                <mat-slide-toggle
                  class="shrink-0"
                  formControlName="SHOWDISBURSEMENTS"
                  (change)="checkboxClick('SHOWDISBURSEMENTS')"
                ></mat-slide-toggle>
              </div>

              @if (isSolacitor == 'Solicitor') {
                <div class="justify-content-between block-boxwrap flex">
                  <div class="min-w-0 flex-1">
                    <h6 class="font-size-12 font-weight-800 mt-0 mb-1">
                      Show Inactive Fee Earners in lists
                    </h6>
                    <span class="block text-sm">
                      When running reports, or in the matters window, include inactive users in the
                      list
                    </span>
                  </div>
                  <mat-slide-toggle
                    class="shrink-0"
                    formControlName="SHOWINACTIVEFEEEARNERS"
                    (change)="checkboxClick('SHOWINACTIVEFEEEARNERS')"
                  ></mat-slide-toggle>
                </div>
              }

              <div class="block-boxwrap flex items-start justify-between gap-4">
                <!-- Left -->
                <div class="min-w-0 flex-1">
                  <h6 class="font-size-12 font-weight-800 mt-0 mb-1">Default Task View</h6>

                  <span class="block text-sm">
                    Select what style of view you want your tasks to be displayed in
                  </span>
                </div>

                <mat-form-field appearance="outline" class="w-52 flex-shrink-0">
                  <mat-label>Task View</mat-label>

                  <mat-select
                    formControlName="DEFAULTTASKVIEW"
                    (selectionChange)="changeSelectWindow('DEFAULTTASKVIEW')"
                  >
                    <mat-option value="List">List</mat-option>
                    <mat-option value="Kanban">Kanban</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </mat-card-content>
          </mat-card>
        </form>
        <form class="w-full" [formGroup]="PreferenceForm">
          <mat-card appearance="outlined" class="p-3">
            <mat-card-header class="margin-x-header-0 mb-3 px-4 pb-1">
              <mat-card-title class="text-[20px]">Behaviour</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div>
                @if (isSolacitor == 'Solicitor') {
                  <div class="justify-content-between block-boxwrap flex">
                    <div class="min-w-0 flex-1">
                      <h6 class="font-size-12 font-weight-800 mt-0 mb-1">Default Fee Earner</h6>
                      <span class="block text-sm">
                        When entering time entries & viewing matters. Especially helpful if you are
                        not the Fee Earner but entering time for others
                      </span>
                    </div>
                    <mat-form-field appearance="outline" class="w-52 flex-shrink-0">
                      <mat-label>Default Fee Earner</mat-label>
                      <mat-select
                        (selectionChange)="changeSelectWindow('WORKINGONBEHALFOFGUID')"
                        name="WORKINGONBEHALFOFGUID"
                        formControlName="WORKINGONBEHALFOFGUID"
                      >
                        <!-- <mat-option value="all" checked>All</mat-option> -->
                        <mat-option value checked>None</mat-option>
                        @for (MatterDrop of MatterDropData; track MatterDrop) {
                          <mat-option value="{{ MatterDrop.USERGUID }}">
                            {{ MatterDrop.USERID }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="justify-content-between block-boxwrap flex">
                    <div class="min-w-0 flex-1">
                      <h6 class="font-size-12 font-weight-800 mt-0 mb-1">Default Matter Owner</h6>
                      <span class="block text-sm">
                        Default Matter Owner when creating a new Matter
                      </span>
                    </div>
                    <mat-form-field appearance="outline" class="w-52 flex-shrink-0">
                      <mat-label>Default Matter Owner</mat-label>
                      <mat-select
                        (selectionChange)="changeSelectWindow('DEFAULTOWNERGUID')"
                        name="DEFAULTOWNERGUID"
                        formControlName="DEFAULTOWNERGUID"
                      >
                        <!-- <mat-option value="all" checked>All</mat-option> -->
                        <mat-option value checked>None</mat-option>
                        @for (MatterDrop of MatterDropData; track MatterDrop) {
                          <mat-option value="{{ MatterDrop.USERGUID }}">
                            {{ MatterDrop.USERID }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="justify-content-between block-boxwrap flex">
                    <div class="min-w-0 flex-1">
                      <h6 class="font-size-12 font-weight-800 mt-0 mb-1">
                        Default Primary Fee Earner
                      </h6>
                      <span class="block text-sm">
                        Default Primary Fee Earner when creating a new Matter
                      </span>
                    </div>
                    <mat-form-field appearance="outline" class="w-52 flex-shrink-0">
                      <mat-label>Default Primary Fee Earner</mat-label>
                      <mat-select
                        (selectionChange)="changeSelectWindow('DEFAULTPRIMARYFEEEARNERGUID')"
                        name="DEFAULTPRIMARYFEEEARNERGUID"
                        formControlName="DEFAULTPRIMARYFEEEARNERGUID"
                      >
                        <!-- <mat-option value="all" checked>All</mat-option> -->
                        <mat-option value checked>None</mat-option>
                        @for (MatterDrop of MatterDropData; track MatterDrop) {
                          <mat-option value="{{ MatterDrop.USERGUID }}">
                            {{ MatterDrop.USERID }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="justify-content-between block-boxwrap flex">
                    <div class="min-w-0 flex-1">
                      <h6 class="font-size-12 font-weight-800 mt-0 mb-1">
                        Default Person Assisting
                      </h6>
                      <span class="block text-sm">
                        Default Person Assisting when creating a new Matter
                      </span>
                    </div>
                    <mat-form-field appearance="outline" class="w-52 flex-shrink-0">
                      <mat-label>Default Person Assisting</mat-label>
                      <mat-select
                        (selectionChange)="changeSelectWindow('DEFAULTASSISTANTGUID')"
                        name="DEFAULTASSISTANTGUID"
                        formControlName="DEFAULTASSISTANTGUID"
                      >
                        <!-- <mat-option value="all" checked>All</mat-option> -->
                        <mat-option value checked>None</mat-option>
                        @for (MatterDrop of MatterDropData; track MatterDrop) {
                          <mat-option value="{{ MatterDrop.USERGUID }}">
                            {{ MatterDrop.USERID }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                }

                <div class="justify-content-between block-boxwrap flex">
                  <div class="min-w-0 flex-1">
                    <h6 class="font-size-12 font-weight-800 mt-0 mb-1">Initial Window</h6>
                    <span class="block text-sm">
                      Choose which window you want to display first when you first log in
                    </span>
                  </div>
                  <mat-form-field appearance="outline" class="w-52 flex-shrink-0">
                    <mat-label>Initial Window</mat-label>
                    <mat-select
                      (selectionChange)="changeSelectWindow('INITIALWINDOW')"
                      name="INITIALWINDOW"
                      formControlName="INITIALWINDOW"
                    >
                      @for (Initial of InitialWindow; track Initial) {
                        <mat-option [value]="Initial">{{ Initial }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="justify-content-between block-boxwrap flex">
                  <div class="min-w-0 flex-1">
                    <h6 class="font-size-12 font-weight-800 mt-0 mb-1">Default Quantity Type</h6>
                    <span class="block text-sm">
                      When entering time entries E.g : Units, Hours etc.
                    </span>
                  </div>
                  <mat-form-field appearance="outline" class="w-52 flex-shrink-0">
                    <mat-label>Default Quantity Type</mat-label>
                    <mat-select
                      (selectionChange)="changeSelectWindow('DEFAULTQUANTITYTYPE')"
                      name="DEFAULTQUANTITYTYPE"
                      formControlName="DEFAULTQUANTITYTYPE"
                    >
                      @for (qty of quantType; track qty) {
                        <mat-option [value]="qty.value">{{ qty.Name }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="justify-content-between block-boxwrap flex">
                  <div class="min-w-0 flex-1">
                    <h6 class="font-size-12 font-weight-800 mt-0 mb-1">Open Windows in new Tabs</h6>
                    <span class="block text-sm">
                      To speed up SILQ turn this on so each window Eg : invoices, matters does not
                      need to reload the data as you move around the system
                    </span>
                  </div>
                  <mat-slide-toggle
                    class="shrink-0"
                    formControlName="OPENINNEWTAB"
                    (change)="checkboxClick('OPENINNEWTAB')"
                  ></mat-slide-toggle>
                </div>

                <div class="block-boxwrap">
                  <div class="justify-content-between flex">
                    <div class="min-w-0 flex-1">
                      <h6 class="font-size-12 font-weight-800 mt-0 mb-1">Email Editing Options</h6>
                      <span class="block text-sm">Show CC when sending emails</span>
                    </div>
                    <mat-slide-toggle
                      class="shrink-0"
                      formControlName="SHOWEMAILCC"
                      style="margin-top: 15px !important"
                      (change)="checkboxClick('SHOWEMAILCC')"
                    ></mat-slide-toggle>
                  </div>
                  <br />
                  <div class="justify-content-between flex">
                    <div class="grow">
                      <span class="line-clamp3 d-block">Show BCC when sending emails</span>
                    </div>
                    <mat-slide-toggle
                      class="shrink-0"
                      formControlName="SHOWEMAILBCC"
                      style="margin-top: 0px !important"
                      (change)="checkboxClick('SHOWEMAILBCC')"
                    ></mat-slide-toggle>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </form>
      </div>
      <div class="flex flex-col gap-6">
        <form class="w-full" [formGroup]="PreferenceForm">
          <mat-card appearance="outlined" class="p-3">
            <mat-card-header class="margin-x-header-0 mb-3 px-4 pb-1">
              <mat-card-title class="text-[20px]">Contact Windows</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div>
                <div class="justify-content-between block-boxwrap flex">
                  <div class="min-w-0 flex-1">
                    <h6 class="font-size-12 font-weight-800 mt-0 mb-1">Contact Type Default</h6>
                    <span class="line-clamp3 d-block">
                      Choose which contact type you want to see initially
                    </span>
                  </div>
                  <mat-form-field appearance="outline" class="w-52 flex-shrink-0">
                    <mat-label>Contact Type Default</mat-label>
                    <mat-select
                      (selectionChange)="changeSelectWindow('CONTACTDEFAULTTYPE')"
                      name="CONTACTDEFAULTTYPE"
                      formControlName="CONTACTDEFAULTTYPE"
                    >
                      <mat-option value="all">All Contacts</mat-option>
                      <mat-option value="Person">People</mat-option>
                      <mat-option value="Company">Company</mat-option>
                      <mat-option value="Party">Party</mat-option>
                      <mat-option value="Payee">Payee</mat-option>
                      <mat-option value="Payor">Payor</mat-option>
                      <mat-option value="Payee/Payor">Payee/Payor</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="justify-content-between block-boxwrap flex">
                  <div class="min-w-0 flex-1">
                    <h6 class="font-size-12 font-weight-800 mt-0 mb-1">Start with Default</h6>
                    <span class="line-clamp3 d-block">
                      When searching for a contact choose which letter you want to narrow down to.
                      If you don't want to choose All
                    </span>
                  </div>
                  <mat-form-field appearance="outline" class="w-52 flex-shrink-0">
                    <mat-label>Start with Default</mat-label>
                    <mat-select
                      (selectionChange)="changeSelectWindow('CONTACTSTARTSWITH')"
                      name="CONTACTSTARTSWITH"
                      formControlName="CONTACTSTARTSWITH"
                    >
                      <mat-option value="all">All</mat-option>
                      <mat-option value="a">A</mat-option>
                      <mat-option value="b">B</mat-option>
                      <mat-option value="c">C</mat-option>
                      <mat-option value="d">D</mat-option>
                      <mat-option value="e">E</mat-option>
                      <mat-option value="f">F</mat-option>
                      <mat-option value="g">G</mat-option>
                      <mat-option value="h">H</mat-option>
                      <mat-option value="i">I</mat-option>
                      <mat-option value="j">J</mat-option>
                      <mat-option value="k">K</mat-option>
                      <mat-option value="l">L</mat-option>
                      <mat-option value="m">M</mat-option>
                      <mat-option value="n">N</mat-option>
                      <mat-option value="o">O</mat-option>
                      <mat-option value="p">P</mat-option>
                      <mat-option value="q">Q</mat-option>
                      <mat-option value="r">R</mat-option>
                      <mat-option value="s">S</mat-option>
                      <mat-option value="t">T</mat-option>
                      <mat-option value="u">U</mat-option>
                      <mat-option value="v">V</mat-option>
                      <mat-option value="w">W</mat-option>
                      <mat-option value="x">X</mat-option>
                      <mat-option value="y">Y</mat-option>
                      <mat-option value="z">Z</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="justify-content-between block-boxwrap flex">
                  <div class="min-w-0 flex-1">
                    <h6 class="font-size-12 font-weight-800 mt-0 mb-4">Active Default</h6>
                    <span class="line-clamp3 d-block">
                      Choose whether you want to search for active contacts only, all contacts, etc
                    </span>
                  </div>
                  <mat-form-field appearance="outline" class="w-52 flex-shrink-0">
                    <mat-label>Active Default</mat-label>
                    <mat-select
                      (selectionChange)="changeSelectWindow('CONTACTACTIVE')"
                      name="CONTACTACTIVE"
                      formControlName="CONTACTACTIVE"
                    >
                      <mat-option value="all">All Contacts</mat-option>
                      <mat-option value="1">Active Contacts</mat-option>
                      <mat-option value="0">Inactive Contacts</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </form>
        <form class="w-full" [formGroup]="PreferenceForm">
          <mat-card appearance="outlined" class="p-3">
            <mat-card-header class="margin-x-header-0 mb-3 px-4 pb-1">
              <mat-card-title class="text-[20px]">Productivity</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div>
                <div class="justify-content-between block-boxwrap flex">
                  <div class="min-w-0 flex-1">
                    <h6 class="font-size-12 font-weight-800 mt-0 mb-1">Save Emails To Register</h6>
                    <span class="line-clamp3 d-block">
                      When on, you will required to choose the matter number before sending an email
                    </span>
                  </div>
                  <mat-slide-toggle
                    class="shrink-0"
                    formControlName="SAVEEMAILSTOREGISTER"
                    (change)="checkboxClick('SAVEEMAILSTOREGISTER')"
                  ></mat-slide-toggle>
                </div>
                <div class="justify-content-between block-boxwrap flex">
                  <div class="min-w-0 flex-1">
                    <h6 class="font-size-12 font-weight-800 mt-0 mb-1">
                      Load previous X Days in Diary
                    </h6>
                    <span class="line-clamp3 d-block">
                      Choose how many of the previous day you would to like to load being mindful
                      that the more you load the slower it is.
                    </span>
                  </div>
                  <mat-form-field appearance="outline" class="w-52 flex-shrink-0">
                    <mat-label>Load previous</mat-label>
                    <mat-select
                      (selectionChange)="changeSelectWindow('LOADPREVIOUSXDAYS')"
                      formControlName="LOADPREVIOUSXDAYS"
                    >
                      <mat-option value="30">30 days</mat-option>
                      <mat-option value="60">60 days</mat-option>
                      <mat-option value="90">3 months</mat-option>
                      <mat-option value="120">4 months</mat-option>
                      <mat-option value="150">5 months</mat-option>
                      <mat-option value="183">6 months</mat-option>
                      <mat-option value="365">1 year</mat-option>
                      <mat-option value="730">2 years</mat-option>
                      <mat-option value="1095">3 years</mat-option>
                      <mat-option value="1460">4 years</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="justify-content-between block-boxwrap flex">
                  <div class="min-w-0 flex-1">
                    <h6 class="font-size-12 font-weight-800 mt-0 mb-1">Show Diary Reminder</h6>
                    <span class="block text-sm">
                      If on , you will receive reminders like when appointments are due when logged
                      into SILQ
                    </span>
                  </div>
                  <mat-slide-toggle
                    class="shrink-0"
                    formControlName="SHOWREMINDERS"
                    (change)="checkboxClick('SHOWREMINDERS')"
                  ></mat-slide-toggle>
                </div>
                <!-- <div class="flex justify-content-between block-boxwrap">
              <div>
                <h6 class="font-size-12 font-weight-800 mt-0 mb-4">
                  Conver Document TO PDF
                </h6>
                <span class="line-clamp3 d-block">If on, All document will be saved as
                PDF's</span>
              </div>
              <mat-slide-toggle class="shrink-0" formControlName="CONVERTTOPDF"
              (change)="checkboxClick('CONVERTTOPDF')"></mat-slide-toggle>
            </div> -->

                <div class="justify-content-between block-boxwrap flex">
                  <div class="min-w-0 flex-1">
                    <h6 class="font-size-12 font-weight-800 mt-0 mb-1">Document Thumbnails</h6>
                    <span class="block text-sm">
                      In the Document Register you choose what size your thumbnails/document
                      previews are
                    </span>
                  </div>
                  <mat-form-field appearance="outline" class="w-52 flex-shrink-0">
                    <mat-label>Thumbnail Size</mat-label>
                    <mat-select
                      (selectionChange)="changeSelectWindow('THUMBNAILSIZE')"
                      formControlName="THUMBNAILSIZE"
                    >
                      <mat-option value="small">Small</mat-option>
                      <mat-option value="medium">Medium</mat-option>
                      <mat-option value="large">Large</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="justify-content-between block-boxwrap flex">
                  <div class="min-w-0 flex-1">
                    <h6 class="font-size-12 font-weight-800 mt-0 mb-1">
                      Save reports to cloud storage
                    </h6>
                    <span class="block text-sm">
                      This will save a copy of each report to your cloud storage (Eg Dropbox,
                      SharePoint, OneDrive, etc)
                    </span>
                  </div>
                  <mat-slide-toggle
                    class="shrink-0"
                    formControlName="SAVEREPORTSTONETDRIVE"
                    (change)="checkboxClick('SAVEREPORTSTONETDRIVE')"
                  ></mat-slide-toggle>
                </div>

                <div class="justify-content-between block-boxwrap flex">
                  <div class="min-w-0 flex-1">
                    <h6 class="font-size-12 font-weight-800 mt-0 mb-1">Email CSV export file</h6>
                    <span class="block text-sm">
                      When you export data on a window you will receive a copy of the CSV export
                      file via email
                    </span>
                  </div>
                  <mat-slide-toggle
                    class="shrink-0"
                    formControlName="EMAILCSVFILE"
                    (change)="checkboxClick('EMAILCSVFILE')"
                  ></mat-slide-toggle>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </form>
        <form class="w-full" [formGroup]="PreferenceForm">
          <mat-card appearance="outlined" class="p-3">
            <mat-card-header class="margin-x-header-0 mb-3 px-4 pb-1">
              <mat-card-title class="text-[20px]">User Interface</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div>
                <!-- <div class="flex justify-content-between block-boxwrap">
            <div>
              <h6 class="font-size-12 font-weight-800 mt-0 mb-4">
                User Early Acess Feture Interface
              </h6>
              <span class="line-clamp3 d-block">When on, you will User Early Acess Feture Interface</span>
            </div>
            <mat-slide-toggle class="shrink-0"  formControlName="USEV11UI"
            (change)="themePanel('USEV11UI' , $event)"></mat-slide-toggle>
          </div>
          -->
                <div class="justify-content-between block-boxwrap flex">
                  <div class="min-w-0 flex-1">
                    <h6 class="font-size-12 font-weight-800 mt-0 mb-1">Dark Mode</h6>
                    <span class="block text-sm">
                      If on, your Background will be black insted of white
                    </span>
                  </div>
                  @if (isSolacitor == 'Solicitor') {
                    <mat-slide-toggle
                      class="shrink-0"
                      formControlName="THEMECOLOURToggle"
                      (change)="themeradiobtn($event)"
                    ></mat-slide-toggle>
                  }

                  <!-- <mat-slide-toggle *ngIf="isSolacitor =='Solicitor'" class="shrink-0"  value="theme-blue-gray-dark"
          (change)="themeradiobtn($event.value)"></mat-slide-toggle>

          <mat-slide-toggle *ngIf="isSolacitor !='Solicitor'" class="shrink-0"  value="theme-default"
          (change)="themeradiobtn($event.value)"></mat-slide-toggle>
          -->
                  @if (isSolacitor != 'Solicitor') {
                    <mat-slide-toggle
                      class="shrink-0"
                      formControlName="THEMECOLOURToggle"
                      (change)="themeradiobtn($event)"
                    ></mat-slide-toggle>
                  }
                </div>
                <div class="justify-content-between block-boxwrap flex">
                  <div class="min-w-0 flex-1">
                    <h6 class="font-size-12 font-weight-800 mt-0 mb-1">Hide Favourites</h6>
                    <span class="block text-sm">If on, your Favourite bar will be Hidden</span>
                  </div>
                  <mat-slide-toggle
                    class="shrink-0"
                    name="NAVBARHIDE"
                    formControlName="NAVBARHIDE"
                    (change)="themePanel('NAVBARHIDE')"
                  ></mat-slide-toggle>
                </div>
                <div class="justify-content-between block-boxwrap flex">
                  <div class="min-w-0 flex-1">
                    <h6 class="font-size-12 font-weight-800 mt-0 mb-1">Folded Favourites</h6>
                    <span class="block text-sm">
                      If on, your Favourites bar will be Folded initially
                    </span>
                  </div>
                  <mat-slide-toggle
                    class="shrink-0"
                    name="NAVBARFOLDED"
                    formControlName="NAVBARFOLDED"
                    (change)="themePanel('NAVBARFOLDED')"
                  ></mat-slide-toggle>
                </div>
                <div class="justify-content-between block-boxwrap flex">
                  <div class="min-w-0 flex-1">
                    <h6 class="font-size-12 font-weight-800 mt-0 mb-1">Hide Matter Side Panel</h6>
                    <span class="block text-sm">If on, your Side Panel will be hidden</span>
                  </div>
                  <mat-slide-toggle
                    class="shrink-0"
                    formControlName="SIDEPANELHIDE"
                    (change)="themePanel('SIDEPANELHIDE', $event)"
                  ></mat-slide-toggle>
                </div>

                <div class="justify-content-between block-boxwrap flex">
                  <div class="min-w-0 flex-1">
                    <h6 class="font-size-12 font-weight-800 mt-0 mb-1">Matter Details Tab Text</h6>
                    <span class="block text-sm">
                      Display the Matter Number or Client Name in the Matter Details tab
                    </span>
                  </div>
                  <mat-form-field class="example" appearance="outline" fxFlex="30">
                    <mat-label>MatterDetailsTabText</mat-label>
                    <mat-select #value name="selected" formControlName="MATTERDETAILSTABTEXT">
                      <mat-option value="Matter Number">Matter Number</mat-option>
                      <mat-option value="Client Name">Client Name</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </form>
        <form class="w-full" [formGroup]="PreferenceForm" #scrollToDiv>
          <mat-card appearance="outlined" class="p-3">
            <mat-card-header class="margin-x-header-0 px-4 pb-1">
              <div class="flex flex-col">
                <mat-card-title class="mb-3 text-[20px]">SMTP Configuration</mat-card-title>

                <mat-card-subtitle class="mb-2 !font-normal">
                  Fill this in if you use SMTP for your Email
                </mat-card-subtitle>
              </div>
            </mat-card-header>

            <mat-card-content>
              <div class="mb-4 grid grid-cols-2 gap-4">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>Email Address</mat-label>
                  <input matInput formControlName="SMTPEMAILADDRESS" />
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>Server</mat-label>
                  <input matInput formControlName="SMTPSERVER" />
                </mat-form-field>
              </div>

              <div class="mb-4 flex items-center gap-4">
                <mat-form-field appearance="outline" class="w-120">
                  <mat-label>Port</mat-label>
                  <input matInput type="number" formControlName="SMTPPORT" />
                </mat-form-field>

                <mat-checkbox formControlName="SMTPUSESSL">Use SSL</mat-checkbox>
              </div>

              <div class="grid grid-cols-2 gap-4">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>Username</mat-label>
                  <input matInput formControlName="SMTPUSERNAME" />
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>Password</mat-label>
                  <input
                    matInput
                    [type]="hide ? 'password' : 'text'"
                    formControlName="SMTPPASSWORD"
                  />
                  <mat-icon matSuffix (click)="hide = !hide">
                    {{ hide ? 'visibility_off' : 'visibility' }}
                  </mat-icon>
                </mat-form-field>
              </div>
            </mat-card-content>
          </mat-card>
        </form>
      </div>
    </div>
  </div>
  <div mat-dialog-actions align="end" class="popup_ftr justify-end!">
    <button matButton="filled" [disabled]="isspiner" (click)="preferenceSave()">Save</button>
  </div>
</div>
